import { render } from "./department-grid.vue?vue&type=template&id=bb8a1664"
import script from "./department-grid.vue?vue&type=script&lang=js"
export * from "./department-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__